<template>
  <v-app id="app">
    <router-view></router-view>
    <cookie-law theme="royal" :buttonText="$t('global.button.accept')">
      <div slot="message">
        {{ $t('site.cookie.message') }}
      </div>
    </cookie-law>

    <v-snackbar
      :timeout="snackbar.timeout"
      :right="snackbar.right"
      :top="snackbar.top"
      v-model="snackbar.visible"
      :auto-height="true"
      :color="snackbar.color"
    >
      <p v-if="!snackbar.isHtml">
        {{ snackbar.text }}
      </p>
      <p v-else v-html="snackbar.text"></p>
      <v-btn dark flat @click.native="snackbar.visible = false">X</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import store from '@/store';
import configAnalytics from '@/services/configAnalytics.js';
import utilService from './services/utilService';

export default {
  name: 'App',
  components: {
    CookieLaw,
  },
  computed: {
    isProduction() {
      return utilService.isProduction;
    },
  },
  data() {
    return {
      snackbar: {
        text: '',
        visible: false,
        timeout: 3000,
        right: true,
        top: true,
        isHtml: false,
      },
    };
  },
  mounted() {
    if (this.isProduction) {
      let googletagmanagerScript = document.createElement('script');
      googletagmanagerScript.src =
        'https://www.googletagmanager.com/gtag/js?id=' +
        store.state.citySelected.googleAnalyticsMeasurementId;
      googletagmanagerScript.async = true;

      let fbookScript = document.createElement('script');
      fbookScript.innerHTML =
        `
      /* eslint-disable */
window.dataLayer = window.dataLayer || [];

function gtag() {
  dataLayer.push(arguments);
}
gtag('js', new Date());
gtag('config', '` +
        store.state.citySelected.googleAnalyticsMeasurementId +
        `');

!(function(f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function() {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1657043074512248');
fbq('track', 'PageView');
/* eslint-disable */
      `;

      let fbookNoScriptOneImage = document.createElement('img');
      fbookNoScriptOneImage.setAttribute('height', '1');
      fbookNoScriptOneImage.setAttribute('width', '1');
      fbookNoScriptOneImage.setAttribute(
        'src',
        'https://www.facebook.com/tr?id=1657043074512248&ev=PageView&noscript=1'
      );

      let fbookNoScriptOne = document.createElement('noscript');
      fbookNoScriptOne.appendChild(fbookNoScriptOneImage);

      document.write(googletagmanagerScript.outerHTML);
      document.write(fbookScript.outerHTML);
      document.write(fbookNoScriptOne.outerHTML);
    }
  },
  created() {
    EventBus.$on(keys.eventOnShowNotification, this.showNotification);
    EventBus.$on(keys.updateUserData, this.onUpdateUserData);
    EventBus.$on(keys.citySelected, this.configureAnalytics);

    this.configureAnalytics();

    this.$mam.identify();
  },
  destroyed() {
    EventBus.$off(keys.eventOnShowNotification, this.showNotification);
    EventBus.$off(keys.updateUserData, this.onUpdateUserData);
    EventBus.$off(keys.citySelected, this.configureAnalytics);
  },
  methods: {
    showNotification(data) {
      this.snackbar.isHtml = false;
      if (data.doNotTranslate) {
        this.snackbar.text = data.message;
      } else {
        this.snackbar.text = this.$i18n.t(data.message, data.messageParams);
      }
      if (typeof data.isHtml !== 'undefined') {
        this.snackbar.isHtml = data.isHtml;
      }
      this.snackbar.color = data.type;
      this.snackbar.visible = true;
      this.snackbar.timeout = 3000;
      if (typeof data.timeout !== 'undefined') {
        this.snackbar.timeout = data.timeout;
      }
    },
    configureAnalytics() {
      configAnalytics.setup();
    },
    onUpdateUserData() {
      this.$mam.updateUserProperties();
    },
  },
};
</script>
